import React from 'react';
import { IHTCalculation } from '../../types';

interface Props {
    ihtCalc?: IHTCalculation | null;
    dateOfDeath?: string | null; // YYYY-MM-DD
}

export const ExecutorTaxWarning: React.FC<Props> = ({ ihtCalc, dateOfDeath }) => {
    const taxDue = ihtCalc?.total_tax_due ?? 0;
    if (taxDue <= 0) return null;

    // Check if the 6-month payment deadline has passed
    let deadlinePassed = false;
    if (dateOfDeath) {
        const dod = new Date(dateOfDeath);
        if (!isNaN(dod.getTime())) {
            const deadline = new Date(dod);
            deadline.setMonth(deadline.getMonth() + 6);
            deadlinePassed = new Date() > deadline;
        }
    }

    const fmt = (n: number) => n.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });

    return (
        <div className="bg-[#FAF3E0] border border-[#E8D89A] rounded p-5">
            <div className="flex-1">
                <h3 className="font-serif text-[18px] font-medium text-[#1A1A1A] m-0 mb-2">Important</h3>
                <p className="text-[13px] text-[#3F3D39] leading-relaxed">
                    Inheritance Tax must usually be paid before probate can be granted. HMRC will normally only issue form IHT421 to the Probate Registry once sufficient tax has been paid.
                </p>
                <p className="text-[13px] text-[#7A5A00] mt-2 font-medium">
                    Estimated amount due: <span className="font-mono tabular-nums">{fmt(taxDue)}</span>
                </p>

                {deadlinePassed && (
                    <div className="mt-3 pt-3 border-t border-[#E8D89A]">
                        <p className="text-[13px] font-serif italic text-[#7A5A00]">
                            Interest may now be accruing on unpaid inheritance tax.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};
